import styled from 'styled-components';
import { colors } from '../../style';
import Button, { ButtonProps } from './button';

const CleanButton = styled(Button).attrs({ variant: 'clean' })<ButtonProps & { width?: React.CSSProperties['width'] }>`
  background: transparent;
  border: none !important;
  padding: 0;
  height: auto;
  width: ${props => props.width || 'auto'};
  color: inherit;

  &:focus-visible:not(.disabled):not([disabled]) {
    box-shadow: 0 0 0 3px ${colors.sky};
    border: none;
    outline: none;
  }

  &:hover,
  &[disabled] {
    background-color: transparent !important;
    outline: none !important;
    border: none !important;
  }
`;

export default CleanButton;
